<template>
  <div id="CustomerAddressesList" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div v-if="moduleId != undefined">
      <!-- <h5> Contact Details 124 </h5> -->
      <form autocomplete="off" v-show="addContactFlag" class="form-horizontal basic-form-container form-custom-select"
            id="ContactForm">
        <div class="form-row row-cols-md-6 row-cols-1">
          <h5 class="col section-title"> Customer Addresses </h5>
          <div class="col">
            <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
              <i class="fp-add"></i>Add
            </button>
          </div>
        </div>
        <div class="table-responsive-sm table-mt-10" :key="contTableKey">
          <table aria-describedby="table" class="table table-sm table-bordered font-1">
            <thead>
            <tr class="table-primary">
              <th scope="col" style="width:35% require">Contact Type</th>
              <th scope="col" class="require" style="width:15%">Name</th>
              <th scope="col" style="width:10%">Contact Method</th>
              <th scope="col" class="require" style="width:15%">Email</th>
              <th scope="col" style="width:10%">Phone No.</th>
              <th scope="col" style="width:10%"> Fax</th>
              <th scope="col" style="width:5%"> Action</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="customerContactArr.length > 0">
              <template v-for="(row, index) in customerContactArr">
                <tr :key="index">
                  <td style="width:20%">
                    <v-select v-model="row.contact_type" name="contact_type" placeholder="Select Contact Type."
                              label="text" :options="notificationTypesArr">
                    </v-select>
                    <div class="field-error">{{ row.contact_type_error_msg }}</div>
                  </td>
                  <td style="width:20%">
                    <input type="text" placeholder="Enter Name" v-model="row.contact_name" :id="'contact_name' + index"
                           name="contact_name" class="form-control">
                    <div class="field-error">{{ row.contact_name_error_msg }}</div>
                  </td>
                  <td style="width:5%">
                    <v-select v-model="row.contact_method" name="contact_method" placeholder="Select Contact Method."
                              label="text" :options="contactMethodArr" class="close-remove">
                    </v-select>
                  </td>
                  <td style="width:20%">
                    <input type="text" placeholder="Enter Email" v-model="row.contact_email"
                           :id="'contact_email' + index" name="contact_email" class="form-control">
                    <div class="field-error">{{ row.contact_email_error_msg }}</div>
                  </td>
                  <td style="width:15%">
                    <input type="text" :id="'contact_phone' + index" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="row.contact_phone"  placeholder="999-999-9999" name="contact_phone">
                    <div class="field-error">{{ row.contact_phone_error_msg }}</div>
                  </td>
                  <td style="width:10%">
                    <input type="text" :id="'contact_fax' + index" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="row.contact_fax"  placeholder="999-999-9999" name="contact_fax">
                    <div class="field-error">{{ row.contact_fax_error_msg }}</div>
                  </td>
                  <td class="text-center" style="vertical-align:middle;width:5%">
                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeLine(index);"> <i
                      class="fp-close color-red"></i> </a></span>
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <td colspan="7" class="text-center">
                  No Record Found.
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div class="alert alert-warning hide col-sm-6" id="alertError">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
          <strong id="errorMsg" class="field-error"></strong>
        </div>
        <div class="btn-groups">
          <button type="submit" id="CreateCustomerBtn" class="btn btn-primary" v-on:click.prevent="CreateContact">
            <i class="fp-reload"> </i> Update
          </button>
          <button type="submit" id="cancelCustomerBtn" class="btn btn-tertiary" v-on:click.prevent="CancelEditContact">
            <i class="fp-close"> </i> Cancel
          </button>
        </div>
      </form>
      <div class="bg-white data-table p-0" v-show="!addContactFlag">

        <vue-good-table
          ref="listCustomerAddressesTable"
          mode="remote"
          title="Customer Contact"
          @on-page-change="onPageChange"
          @on-selected-rows-change="selectionChanged"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          :totalRows="totalRecords"
          :columns="columns"
          :rows="rows"
          :pagination-options="{
                        enabled: (totalRecords > serverParams.perPage ? true:false),
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
          :search-options="{
                    enabled: false,
                    }">
          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
            <div :key="key">
              <template v-if="props.column.field == 'action'">
                <template v-if="canUpdateCustomerContact == true">
                  <!-- <router-link title="Edit Customer Contact" class="fp-edit" v-bind:to="{name: 'CustomerContactEdit',params:{id:props.row.id}}"></router-link> -->
                </template>
              </template>
              <template v-else>
                {{ props.formattedRow[props.column.field] }}
              </template>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>

    <div id="page-content-wrapper" class="admin-content-area" v-else>
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">{{ pageTitle }}</div>
          <!-- Button for Clear Cache -->
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
          <div class="btn-groups pull-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
            </a>
            <router-link v-if="canAddCustomerContact == true  && hideButton === false" class="btn btn-primary"
                         v-bind:to="{name: 'CustomerContactCreate'}"><i class="fp-add"></i> Add
            </router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'CustomerAddressesList'" ref="filterComponent"
                                      @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch
              no. is {{ batchNum }}.
              <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                           @click.native="batchProcess = 0"> Click Here
              </router-link>
              to check file status!
            </p>
            <section class="bg-white data-table">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'CustomerAddressesList'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                ref="listCustomerAddressesTable"
                mode="remote"
                title="Customer Contact"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                @on-select-all="onSelectAll"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                :select-options="{
                                    enabled: canDeleteCustomerContact,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                :search-options="{
                                    enabled: false,
                                    }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'" class='text-right'>
                      <router-link v-bind:key="'delete' + key" v-if="canUpdateCustomerContact"
                                   title="Edit Customer Contact" class="fp-edit"
                                   v-bind:to="{name: 'CustomerContactEdit',params:{id:props.row.id}}">
                      </router-link>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>
                <div slot="selected-row-actions">
                  <button v-if="canDeleteCustomerContact" id="deleteCustomerContactBtn"
                          v-on:click.prevent="customerContactDelete" class="btn btn-danger">Delete
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import {contractMixins} from '../mixins/contractMixins';
// import InputMask from 'vue-input-mask';

// Vue.component('input-mask', InputMask);

let msgServer;

export default {
  name: "CustomerAddressesList",
  mixins: [commonMixins, dataTableMixins, contractMixins],
  props: {
    listFlag: {
      type: String,
      required: false,
      default: undefined
    },
    moduleId: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    batchProcess: 0,
    contTableKey: 1,
    batchNum: "",
    pageTitle: "Customer Addresses List",
    hideButton: false,
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    columns: [
      {
        label: 'Company Code',
        field: 'company_code',
        filterable: true,
        fpFieldType: 'option',
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "company", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems : ['000', '001', '002'], //dropdown (with selected values) instead of text input
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Customer Number',
        field: 'customer_no',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Suffix',
        field: 'suffix',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Customer Name',
        field: 'customer_name',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Status',
        field: 'customer_status',
        hidden: false,
        fpFieldType: "option",
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "All", // placeholder for filter input
          filterDropdownItems: ['Active', 'Inactive'],
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'PO Number Required',
        field: 'po_required',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Work Order Reminder Message',
        field: 'work_order_reminder_message',
        fpFieldType: "text",
        filterable: false,
        sortable: false,
        hidden: false,
      },
      {
        label: 'Terms Code',
        field: 'terms_code',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Customer Class Code',
        field: 'customer_class_code',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Address Line One',
        field: 'address_line_one',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Address Line Two',
        field: 'address_line_two',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Address Line Three',
        field: 'address_line_three',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Address Line Four',
        field: 'address_line_Four',
        fpFieldType: "text",
        filterable: false,
        sortable: false,
        hidden: false,
      },
      {
        label: 'Address Line Five',
        field: 'address_line_five',
        fpFieldType: "text",
        filterable: false,
        sortable: false,
        hidden: false,
      },
      {
        label: 'Address Line Six',
        field: 'address_line_six',
        fpFieldType: "text",
        filterable: false,
        sortable: false,
        hidden: false,
      },
    ],
    rows: [],
    totalRecords: 0,
    canDeleteCustomerContact: false,
    loading: false,
    canUpdateCustomerContact: false,
    action: 'list',
    canAddCustomerContact: false,
    pageKey: "_customer_addressed_list_",
    showAddButton: false,
    addContactFlag: false,
    customerContactArr: [],
    notificationTypesArr: [],
    contact_type: "",
    contact_name: "",
    contact_method: {text: "Email", value: "email"},
    contact_email: "",
    contact_phone: "",
    contact_fax: "",
    contact_type_error_msg: "",
    contact_name_error_msg: "",
    contact_email_error_msg: "",
    contact_phone_error_msg: "",
    contact_fax_error_msg: ""
  }),
  metaInfo() {
    if (this.moduleId === undefined) {
      return {
        title: "Customer Addresses List | " +process.env.COPYRIGHT_NAME
      }
    }
  },
  watch: {

    // check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name === 'list_customer_contact') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name === 'delete_customer_contact') {
            self.canDeleteCustomerContact = self.$route.query.flag !== 'contactReport';

          }
          if (permissions[i].name === 'add_customer_contact') {
            self.canUpdateCustomerContact = true;
            self.canAddCustomerContact = true;
          }
        }
      }
    }
  },
  created: function () {
    this.serverParams.stopRequest = true;
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    msgServer.close();
  },
  mounted: function () {
    var self = this;
    self.loadFieldData(['notification_types', 'location']);
    if (self.$route.query.flag === 'contactReport') {
      self.hideButton = true;
      self.pageTitle = "Customer Addresses"

      for (let index = 0; index < this.columns.length; index++) {

        if (this.columns[index].field === 'action') {
          this.$set(this.columns[index], 'hidden', true);
        }
      }

    }

    //In this page Permission Call is required
    self.getPermissions();

    //when component list directly call from url instead of in view page than call permission request
    if (self.moduleId === undefined) {
//                self.getPermissions();
    } else {

      // for now hide unit and name datatable column
      // if user come from customer view page than remove customer column
      if (self.listFlag === "customerContact") {
        for (let index = 0; index < this.columns.length; index++) {

          if (this.columns[index].field === 'customer_id') {
            this.$set(this.columns[index], 'hidden', true);
          }
        }
      }
      self.loadList();
    }
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listCustomerAddressesTable.unselectAllInternal();
    },
    addRow() {
      var self = this;
      var error = false;
      var default_inv = "";
      var obj = self.notificationTypesArr;
      $.each(obj, function (key, codevalue) {
        if (codevalue.code == 'I') {
          default_inv = {
            value: codevalue.value,
            text: codevalue.text,
          };
        }

      });

      if (self.customerContactArr.length < 1) {

        self.customerContactArr.push({
          contact_id: 0,
          contact_type: default_inv,
          contact_name: "",
          contact_method: {text: "Email", value: "email"},
          contact_email: "",
          contact_phone: "",
          contact_fax: "",
          contact_type_error_msg: "",
          contact_name_error_msg: "",
          contact_email_error_msg: "",
          contact_phone_error_msg: "",
          contact_fax_error_msg: ""
        });

      } else {
        var index = self.customerContactArr.length - 1;
        self.customerContactArr[index].contact_name_error_msg = "";
        self.customerContactArr[index].contact_email_error_msg = "";
        self.customerContactArr[index].contact_phone_error_msg = "";
        self.customerContactArr[index].contact_type_error_msg = "";
        self.customerContactArr[index].contact_fax_error_msg = "";

        if (self.customerContactArr[index].contact_type === "" || self.customerContactArr[index].contact_type == null || !self.customerContactArr[index].contact_type.value) {
        }

        if (self.customerContactArr[index].contact_name == null || self.customerContactArr[index].contact_name.trim() === "") {
          self.customerContactArr[index].contact_name_error_msg = "Name Require.";
          error = true;
        }

        if (self.customerContactArr[index].contact_email == null || self.customerContactArr[index].contact_email.trim() === "") {
          self.customerContactArr[index].contact_email_error_msg = "Email Require.";
          error = true;
        } else {
          if (self.customerContactArr[index].contact_email && !self.validEmail(self.customerContactArr[index].contact_email)) {
            self.customerContactArr[index].contact_email_error_msg = "Enter Valid Email.";
            error = true;
          }
        }

        if (self.customerContactArr[index].contact_phone.trim() === "___-___-____") {
        } else {
          var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if (!self.customerContactArr[index].contact_phone.trim().match(phoneRE)) {
            self.customerContactArr[index].contact_phone_error_msg = "Enter Valid Phone No.";
            error = true;
          }
        }

        if (self.customerContactArr[index].contact_fax.trim() !== "___-___-____") {
          var faxRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if (!self.customerContactArr[index].contact_fax.trim().match(faxRE)) {
            self.customerContactArr[index].contact_fax_error_msg = "Enter Valid Fax.";
            error = true;
          }
        }

        if (!error) {
          self.customerContactArr.push({
            contact_id: 0,
            contact_type: default_inv,
            contact_name: "",
            contact_method: {text: "Email", value: "email"},
            contact_email: "",
            contact_phone: "",
            contact_fax: "",
            contact_type_error_msg: "",
            contact_name_error_msg: "",
            contact_email_error_msg: "",
            contact_phone_error_msg: "",
            contact_fax_error_msg: ""
          });
        }
      }
    },
    addContact() {
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.addContactFlag = true;
      $.ajax({
        url: process.env.ROOT_API + "/customer/" + segments[3],
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          console.log(data);
          if (data.status === "success") {
            // console.log("segments[3]");
            if (data.content.customer_contacts !== undefined && data.content.customer_contacts !== null) {
              self.customerContactArr = data.content.customer_contacts;
            } else {
              self.customerContactArr = [];
            }
          }
        }
      });
    },
    removeLine(index) {
      var self = this;
      if (self.customerContactArr.length >= 1) {
        if (self.customerContactArr[index].contact_id === 0) {
          self.customerContactArr.splice(index, 1);
        } else {
          if (confirm('Are you sure that you want to remove this contact? ')) {

            self.loading = true;
            $.ajax({
              url: process.env.ROOT_API + "/customercontact/delete",
              type: "POST",
              data: {'id': self.customerContactArr[index].contact_id},
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                if (data.status === "success") {
                  setTimeout(function () {
                    self.addContact();
                    self.addContactFlag = true;
                  }, 50);
                }
              },
              error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR, true, 'contact-delete')
              },
            });
          }
        }
      }
    },

    // exportReports: function () {
    //   var self = this;
    //   this.action = "export";
    //   this.loadList();
    //   EventBus.$emit("clearSelection", false);
    // },

    selectionChanged(param) {
      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length === 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      return;
      //var rowData = self.$refs['listCustomerContactTable'].selectedRows;
      //console.log(rowData);
    },
    CancelEditContact() {
      var self = this;
      self.addContactFlag = false;
      self.loadList();
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    CreateContact() {

      var self = this;
      var error = false;
      var path = window.location.pathname;
      var segments = path.split("/");

      if (self.customerContactArr.length >= 1) {

        for (var i = 0; i < self.customerContactArr.length; i++) {

          self.customerContactArr[i].contact_name_error_msg = "";
          self.customerContactArr[i].contact_email_error_msg = "";
          self.customerContactArr[i].contact_phone_error_msg = "";
          self.customerContactArr[i].contact_type_error_msg = "";
          self.customerContactArr[i].contact_fax_error_msg = "";

          if (self.customerContactArr[i].contact_type === "" || self.customerContactArr[i].contact_type == null || !self.customerContactArr[i].contact_type.value) {
            self.customerContactArr[i].contact_type_error_msg = "Contact Type Require.";
            error = true;
          }

          if (self.customerContactArr[i].contact_name === "" || self.customerContactArr[i].contact_name == null) {

            self.customerContactArr[i].contact_name_error_msg = "Name Require.";
            error = true;
          }

          if (self.customerContactArr[i].contact_email.trim() === "" && self.customerContactArr[i].contact_phone.trim() === "___-___-____") {

            if (self.customerContactArr[i].contact_email == null || self.customerContactArr[i].contact_email.trim() === "") {
              self.customerContactArr[i].contact_email_error_msg = "Email OR Phone No. Require.";
              error = true;
            }

            if (self.customerContactArr[i].contact_phone.trim() === "___-___-____") {

              self.$set(self.customerContactArr[i], 'contact_phone_error_msg', "Email OR Phone No. Require.");
              error = true;
            }
          }
          if (self.customerContactArr[i].contact_email.trim() !== "" && self.customerContactArr[i].contact_email.trim() != null) {
            if (self.customerContactArr[i].contact_email && !self.validEmail(self.customerContactArr[i].contact_email)) {
              self.customerContactArr[i].contact_email_error_msg = "Enter Valid Email.";
              error = true;
            }
          }
          if (self.customerContactArr[i].contact_phone.trim() !== "" && self.customerContactArr[i].contact_phone.trim() !== "___-___-____") {
            var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (!self.customerContactArr[i].contact_phone.trim().match(phoneRE)) {
              self.customerContactArr[i].contact_phone_error_msg = "Enter Valid Phone No.";
              error = true;
            }
          }
          if (self.customerContactArr[i].contact_fax.trim() !== "" && self.customerContactArr[i].contact_fax.trim() !== "___-___-____") {
            var faxRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (!self.customerContactArr[i].contact_fax.trim().match(faxRE)) {
              self.customerContactArr[i].contact_fax_error_msg = "Enter Valid Fax.";
              error = true;
            }
          }
        }
      }

      if (!error) {
        self.loading = true;
        var custContactArr = [];
        var fields = $("#ContactForm").serializeArray();
        fields.push({name: "id", value: segments[3]});

        //customer contact array
        for (var i = 0; i < self.customerContactArr.length; i++) {
          custContactArr.push({
            contact_id: self.customerContactArr[i].contact_id,
            contact_type: self.customerContactArr[i].contact_type,
            contact_name: self.customerContactArr[i].contact_name,
            contact_email: self.customerContactArr[i].contact_email,
            contact_phone: self.customerContactArr[i].contact_phone,
            contact_fax: (self.customerContactArr[i].contact_fax.trim() !== "___-___-____") ? self.customerContactArr[i].contact_fax.trim() : "",
            contact_method: (self.customerContactArr[i].contact_method != null &&
              self.customerContactArr[i].contact_method !== "") ? self.customerContactArr[i].contact_method.value : ""
          });
          //}
        }

        fields.push({name: "customer_contact", value: JSON.stringify(custContactArr)});
        $.ajax({
          url: process.env.ROOT_API + "/customer_contact/update",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status === "success") {
              self.addContactFlag = false;
              self.loadList();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true, 'customer-contact-update')
          }
        });
      } else {

        self.contTableKey = self.contTableKey + 1;
        self.errorValidationFocus();

      }

    },


    loadList() {
      var self = this;
      self.loading = true;
      var data = this.$refs['listCustomerAddressesTable'].selectedRows;
      var selectedRows = [];

      for (var i = 0; i < data.length; i++) {
        selectedRows.push(self.$refs['listCustomerAddressesTable'].selectedRows[i].id)
      }
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        all: self.serverParams.selectedAll,
        selectedRows: selectedRows,
        action: self.action,
        flag: self.listFlag,
        id: self.moduleId,
        export_type: 'only_list'
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/customercontact/addressesDetails",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          console.log(data);
          if (data.status === "success") {
            if (self.action === "delete") {

              self.action = "list";
              $("#deleteCustomerContactBtn").val("Delete");

              self.$refs.filterComponent.clearSelectAll();
              self.loadList();
              EventBus.$emit('clear-all-flags', false);   //hide alert of selection

            } else if (self.action === "export" || self.action === "export_queue") {

              if (data.code === "201") {
                alert(data.message);
              } else {

                if (self.action === "export") {

                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {
                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }

              self.action = "list";
              self.loadList();
              return;

            } else {
              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              self.filteredFlag = false;
            }


          } else {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
          if (data.content.totalRecords === 0) {
            self.showAddButton = true;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (self.action === "delete") {
            self.generateStatusCodeMessage(jqXHR, true, 'contactmessage')
          } else {
            self.generateStatusCodeMessage(jqXHR, false, 'contactmessage')
          }
        }
      });
    },

    customerContactDelete() {
      if (confirm('Are you sure that you want to delete this Customer Contact? ')) {

        this.action = "delete";
        $("#deleteCustomerContactBtn").val("Deleting ...");

        this.loadList();

      }
    },
    syncCustomerContctRate() {

      var self = this;
      self.loading = true;
      $("#syncContactBtn").text("Syncing...");
      $("#syncContactBtn").prop("disabled", true);

      $.ajax({
        url: process.env.ROOT_API + "/sync-customercontact",
        type: "GET",
        // data: 'id=' + use,
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {

          self.loading = false;
          $("#syncContactBtn").text("Sync");
          $("#syncContactBtn").prop("disabled", false);

          if (data.status == 'success') {

            self.$swal({
              // title: data.content + " " ,
              text: data.content + " Customer Contact are Sync.",
              type: "success",
              confirmButtonText: "Confirm",
            }).then(result => {
              if (result.value) {
                self.loadList();
              }
            });
          }
        },
        error: function (jqXHR) {

          self.loading = false;
          $("#syncContactBtn").text("Sync");
          $("#syncContactBtn").prop("disabled", false);

          self.generateStatusCodeMessage(jqXHR, true, 'synccontactmessage')
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/CustomerAddressesReport.vue